/* eslint-disable no-underscore-dangle */
/* eslint-disable no-useless-constructor */
/* eslint-disable class-methods-use-this */
// entering entered exiting exited
const markup = /* html */`
<style>
    .backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: transparent;
        transition: backdrop-filter 200ms ease;
        z-index: var(--z-index, 200);
         cursor: pointer;
    }

    :host([transition="exited"]) .backdrop {
        background-color: transparent;
        pointer-events: none;
    }

    .window {
        position: fixed;
        z-index: calc(var(--z-index, 200) + 1);
        width: fit-content;
        height: fit-content;
        max-width: 100vw;
        max-height: 100vh;
        overflow: auto;
        transition:
            transform 800ms cubic-bezier(0.4,0,0.2,1) 0ms,
            opacity 300ms cubic-bezier(0.4,0,0.2,1) 0ms;
    }

    /* Мобильные и планшеты */
    @media (max-width: 1023px) {
        :host([transition="entered"]) .backdrop {
            background-color: transparent;
            <!-- background-color: #f8f8f8; -->
            <!-- backdrop-filter: blur(1px); -->
            <!-- -webkit-backdrop-filter: blur(1px); -->
        }
        .window {
            position: fixed;
            left: 50%;
            bottom: 0;
            transform: translateX(150%);
            transition: transform 700ms;
        }
        :host([transition="entered"]) .window {
            transform: translateX(-50%);
        }
        :host([transition="exited"]) .window {
            transition:
                transform 800ms cubic-bezier(0.4,0,0.2,1) 0ms,
                opacity 300ms cubic-bezier(0.4,0,0.2,1) 700ms;
            transform: translateX(150%);
            opacity: 0;
            pointer-events: none;
        }
    }

    /* Десктопы */
    @media (min-width: 1024px) {
        :host([transition="entered"]) .backdrop {
            background-color: transparent;
            backdrop-filter: blur(20px);
            -webkit-backdrop-filter: blur(20px);
        }

        :host([backdrop="clear"]) .backdrop {
            background-color: transparent;
            backdrop-filter: unset;
            -webkit-backdrop-filter: unset;
        }

        .window {
            position: fixed;
            top: 0;
            right: 0;
            transform: translateX(150%);
        }
        :host([transition="entered"]) .window {
            transform: translateX(0%);
        }
        :host([transition="exited"]) .window {
            transition:
                transform 800ms cubic-bezier(0.4,0,0.2,1) 0ms,
                opacity 300ms cubic-bezier(0.4,0,0.2,1) 700ms;
            transform: translateX(150%);
            opacity: 0;
            pointer-events: none;
        }
    }
</style>

<div class="wrapper">
    <div class="backdrop">
    </div>
    <div class="window">
        <slot></slot>
    </div>
</div>
`;

export class AsidePanel extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = markup;
    }

    set onClose(cb) { this._onClose = cb; }

    get onClose() { return this._onClose; }

    connectedCallback() {
        const backdrop = this.shadowRoot.querySelector('.backdrop');
        if (backdrop) {
            backdrop.addEventListener('click', this._onBackdropClick);
        }
    }

    disconnectedCallback() {
        const backdrop = this.shadowRoot.querySelector('.backdrop');
        if (backdrop) {
            backdrop.removeEventListener('click', this._onBackdropClick);
        }
    }

    static get observedAttributes() {
        return ['transition'];
    }

    // attributeChangedCallback(name, oldValue, newValue) {
    //     console.log(name, oldValue, newValue);
    // }

    adoptedCallback() {
    }

    _onBackdropClick = () => {
        if (this._onClose) this._onClose();
    };
}


